import image2 from "assets/images/cs/client-charter/2.png";
import image3 from "assets/images/cs/client-charter/3.png";
import image4 from "assets/images/cs/client-charter/4.png";

export const goldPrice = {
  date: "23/10/2024",
  prices: [
    {
      weight: "5g",
      buy: "1,852.34",
      sell: "2,102.89",
    },
    {
      weight: "10g",
      buy: "3,704.68",
      sell: "4,134.38",
    },
    {
      weight: "20g",
      buy: "7,409.36",
      sell: "8,201.55",
    },
    {
      weight: "50g",
      buy: "18,523.40",
      sell: "20,367.38",
    },
    {
      weight: "100g",
      buy: "37,046.79",
      sell: "40,631.85",
    },
    {
      weight: "500g",
      buy: "185,233.95",
      sell: "202,374.90",
    },
    {
      weight: "1000g",
      buy: "370,467.90",
      sell: "402,764.95",
    },
  ],
};

export const unitTrustPrice = {
  date: "21/10/2024",
  funds: [
    {
      fund: "AMISLAMIC GROWTH (RM)",
      nav: "0.6531",
    },
    {
      fund: "RHB ISLAMIC ASEAN MEGATREND (RM)",
      nav: "0.9103",
    },
    {
      fund: "RHB SHARIAH CHINA FOCUS FUND (RM)",
      nav: "1.3795",
    },
    {
      fund: "BIMB-ARABESQUE I GLOBAL DIVIDEND FUND 1 (RM)",
      nav: "0.4911",
    },
    {
      fund: "BIMB-ARABESQUE I GLOBAL SHARIAH SUSTAINABLE EQUITY FUND (RM)",
      nav: "0.2976",
    },
    {
      fund: "BIMB SHARIAH INCOMEPLUS FUND",
      nav: "1.0133",
    },
    {
      fund: "BIMB ESG SUKUK FUND",
      nav: "0.2588",
    },
    {
      fund: "ABERDEEN STANDARD ISLAMIC WORLD EQUITY FUND (RM)",
      nav: "0.6456",
    },
    {
      fund: "PRINCIPAL ISLAMIC ASIA PACIFIC DYNAMIC EQUITY FUND (RM)",
      nav: "0.5898",
    },
    {
      fund: "PRINCIPAL ISLAMIC LIFETIME SUKUK FUND (RM)",
      nav: "1.3166",
    },
    {
      fund: "PRINCIPAL ISLAMIC GLOBAL TECHNOLOGY FUND​-HEDGE (RM)",
      nav: "1.4325",
    },
    {
      fund: "PRINCIPAL ISLAMIC GLOBAL TECHNOLOGY FUND​ (RM)",
      nav: "1.4230",
    },
    {
      fund: "PRINCIPAL ISLAMIC LIFETIME BALANCED FUND (RM)",
      nav: "0.5148",
    },
    {
      fund: "PRINCIPAL ISLAMIC SMALL CAP OPPORTUNITIES FUND (RM)",
      nav: "0.8806",
    },
    {
      fund: "PRINCIPAL ISLAMIC GLOBAL SELECTION AGGRESSIVE FUND (RM)",
      nav: "1.0591",
    },
    {
      fund: "PRINCIPAL ISLAMIC GLOBAL SELECTION MODERATE CONSERVATIVE FUND (RM)",
      nav: "1.0216",
    },
    {
      fund: "PRINCIPAL ISLAMIC GLOBAL SELECTION MODERATE FUND (RM)",
      nav: "0.9669",
    },
    {
      fund: "NOMURA GLOBAL SHARIAH SEMICONDUCTOR FUND (RM)",
      nav: "1.7119",
    },
    {
      fund: "NOMURA GLOBAL SHARIAH SUSTAINABLE EQUITY FUND (RM)",
      nav: "1.5293",
    },
    {
      fund: "NOMURA GLOBAL SHARIAH STRATEGIC GROWTH FUND (RM)",
      nav: "1.2315",
    },
    {
      fund: "NOMURA I-INCOME FUND - CLASS R (RM)",
      nav: "0.8125",
    },
    {
      fund: "MANULIFE SHARIAH GLOBAL REIT FUND (RM)",
      nav: "0.4739",
    },
    {
      fund: "MANULIFE SHARIAH CHINA EQUITY FUND (RM)",
      nav: "0.3199",
    },
    {
      fund: "MANULIFE SHARIAH INDIA EQUITY FUND (RM)",
      nav: "0.6291",
    },
    {
      fund: "MANULIFE SHARIAH INDONESIA EQUITY FUND (RM)",
      nav: "0.4078",
    },
    {
      fund: "AHAM SHARIAH GOLD TRACKER FUND (RM)",
      nav: "0.6944",
    },
    {
      fund: "AHAM AIIMAN INCOME PLUS FUND (RM)",
      nav: "0.5811",
    },
  ],
};

export const clientCharterItems = [
  {
    label: "Privacy Policy",
    title: "<span>Being respectful</span> of our customers' privacy concern",
    description:
      "alrajhi bank Malaysia ensures that our customers' personal and financial information are maintained, protected and safeguarded at all times and will not be shared by any unauthorised parties in any unlawful and unauthorised manner. ",
    image: image3,
  },
  {
    label: "Reliable and Quality Service",
    title:
      "We strive to provide our customers with products and services that are <span>best suited and beneficial for them</span>",
    description:
      "At alrajhi bank Malaysia, our staff are continuously trained to enable them to service customers effectively and maintain consistent and efficient quality service of high standards of professionalism that reflect our values.<br/>Customers visiting our Branches are generally served within 10 minutes and a 24-hour dedicated helpline has been set up to address any queries.",
    image: image4,
  },
  {
    label: "Transparency of Products and Services",
    title:
      "We take pride in being a <span>reliable banking partner</span> that honours our commitment to our customers",
    description:
      "Representing the Bank's products in a clear, responsible, accurate manner and by disclosing relevant and material terms and conditions relating to the products and services offered. All our customers are treated as equal with the same products, terms and services offered. This ensures that our customers' expectations are matched with our offerings.",
    image: image2,
  },
];
